import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { MegaMenuColumn } from '@frontend-site/main-header/domain';

@Component({
    selector: 'p-mega-menu-column',
    templateUrl: './megaMenu-column.component.html',
    styleUrls: ['./megaMenu-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MegaMenuColumnComponent {
    @Input() column: MegaMenuColumn = {} as MegaMenuColumn;
    @Output() close = new EventEmitter();
    constructor() {}
}
